import { Box, BoxProps } from '@mui/material';
import React, { useMemo } from 'react';
import { NavigateFunction } from 'react-router';
import DIContainer from 'services/DIContainer';
import BackgroundListLoaderButton from './BackgroundListLoaderButton';
import PaginationButtons from './PaginationButtons';

/**
 * Ключ - название модели (MODEL_NAME), с которой предстоит работать, значение - dto для получения её списка (если есть)
 * В виде объекта сделано, т.к. на дженериках это единственный способ
 */
type ModelData = {
  [K in DIContainer.ModelsWithActionServices]?: Parameters<DIContainer['storageActions']['models'][K]['getList']>[0];
};

/** Если НЕ требуется кнопка loadMore */
type StandardProps = BoxProps & {
  pagination?: Pagination;
  /** @deprecated */
  navigate?: NavigateFunction;
  /** Параметр поиска, который всегда будет применяться */
  initialFilter?: LocationSearchObject;

  showLoadMoreButton: false;
  // Далее в этом сценарии не нужно
  modelData?: ModelData;
  filterOptions?: LocationSearchObjectOptions;
  listPath?: string;
};

/** Если требуется кнопка loadMore */
type ExtendedProps = BoxProps & {
  pagination?: Pagination;
  /** @deprecated */
  navigate?: NavigateFunction;
  initialFilter?: LocationSearchObject;

  showLoadMoreButton?: true;
  modelData: ModelData;
  /** Если при отправке фильтра из адресной строки фронта нужно что-то игнорировать */
  filterOptions?: LocationSearchObjectOptions;
  /** Если используется нестандартный адрес */
  listPath?: string;
};

function PaginationBlock(props: StandardProps | ExtendedProps) {
  const {
    sx,
    pagination,
    navigate: deprecatedNavigate,
    showLoadMoreButton: _showLoadMoreButton,
    modelData,
    filterOptions,
    listPath,
    initialFilter,
    ...rest
  } = props;
  const showLoadMoreButton = props.showLoadMoreButton === undefined || props.showLoadMoreButton === true;

  const [MODEL_NAME, dto] = useMemo(() => {
    if (showLoadMoreButton) {
      const MODEL_NAME = Object.keys(props.modelData)[0] as DIContainer.ModelsWithActionServices | undefined;
      const dto = MODEL_NAME && props.modelData[MODEL_NAME];
      return [MODEL_NAME, dto] as const;
    } else {
      return [];
    }
  }, []);

  if (!pagination || pagination.totalPages < 2) {
    return null;
  }

  return (
    <Box
      sx={{ mt: 3, display: { xs: 'grid', md: 'flex' }, gridTemplateColumns: '1fr auto', alignItems: 'center', gap: 2, ...sx }}
      {...rest}
    >
      {showLoadMoreButton && MODEL_NAME && (
        <BackgroundListLoaderButton
          lastLoadedPage={pagination.pageNumber}
          totalPages={pagination.totalPages}
          MODEL_NAME={MODEL_NAME}
          dto={dto}
          filterOptions={filterOptions}
          listPath={listPath}
          initialFilter={initialFilter}
          sx={{ gridColumn: 'span 2' }}
        />
      )}
      <PaginationButtons page={pagination.pageNumber} count={pagination.totalPages} initialFilter={initialFilter} />
    </Box>
  );
}

export default React.memo(
  PaginationBlock,
  (prevProps, nextProps) =>
    // prevProps.modelData === nextProps.modelData && // Из-за этого будет обновляться практически всегда
    Boolean(prevProps.pagination) === Boolean(nextProps.pagination) &&
    prevProps.pagination?.pageNumber === nextProps.pagination?.pageNumber &&
    prevProps.pagination?.totalPages === nextProps.pagination?.totalPages
);
